import React 
from "react";
import HeaderPhone from "../../assets/images/icon-phone.svg";
import Service1 from "../../assets/images/customer-support.png";
import IconWhatsapp from "../../assets/images/icon-whatsapp.svg";

import Modal from "react-bootstrap/Modal";
import "../../pages/Home/home.scss";

export default function CallingModal({ show, handleClose,modalPrice }) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      className="deal-modal"
    >
      <Modal.Body className="p-0 modal-body">
        <div className="modal-body-top text-center">
          <h4>Get Cheapest Airline Tickets Starting at ${modalPrice}*</h4>
          <h5>Want to Book at the Lowest Price?</h5>
          <div className="color-primary text-uppercase font-weight-bold">
            CALL US TO GET DEALS UP TO $250
          </div>
          <p className="font-weight-500 mb-3">
            <em>Lower than online*</em>
          </p>
          <a href="tel:7734658500" className="btn-primary-new mt-3">
            <span> <img src={IconWhatsapp} className="mr-md-3 mr-2 whatsapp-icon" alt="whatsapp icon" /></span> 773-465-8500
          </a>
        </div>
        <div className="modal-body-bottom">
          <div className="font-size-14 text-center font-weight-500">
            Thanks to our exclusive airline contracts, we can offer the best
            discount fares. Call Us Free or Request a Quote to get unpublished
            airline deals and insider phone-only offer!
          </div>
          <h6 className="color-primary">How to Book and Save More?</h6>
          <div className="modal-footer-services">
            <div className="modal-footer-service-item">
              <div className="searvice-img">
                <img src={HeaderPhone} alt="Phone" className="img-fluid" />
              </div>
              <div className="searvice-desc">
                Call us to speak to one of our Travel Agents
              </div>
            </div>
            <div className="modal-footer-service-item">
              <div className="searvice-img">
                <img src={Service1} alt="Service" className="img-fluid" />
              </div>
              <div className="searvice-desc">
                Your agent will reply with a free personalized travel quote via
                phone/email/chat.
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
